import { render, staticRenderFns } from "./KitDetailRow.vue?vue&type=template&id=61ba000e&"
import script from "./KitDetailRow.vue?vue&type=script&lang=js&"
export * from "./KitDetailRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports